import React from "react";

const Razor_CSharp_Variables = () => {
  return (
    <div className="tutorial-page">
      <h1>Razor CSharp Variables</h1>
      <p>This is the Razor CSharp Variables page content.</p>
    </div>
  );
};

export default Razor_CSharp_Variables;
